module.exports = __webpack_public_path__ + "static/main-60d86e9a3f20d68537639a27afae28f3.png";